import type { FAQ } from '@/types/home'

export type FAQCategory = 'general' | 'listing' | 'buying' | 'premium'

export interface FAQItem extends FAQ {
  category: FAQCategory
}

export const FAQ_CATEGORIES: { id: FAQCategory; label: string }[] = [
  { id: 'general', label: 'General' },
  { id: 'listing', label: 'Listing & Selling' },
  { id: 'buying', label: 'Buying & Renting' },
  { id: 'premium', label: 'Premium & Services' },
]

export const mockFaqs: FAQItem[] = [
  {
    id: 1,
    category: 'general',
    question: 'What is QBC and how is it different from other portals?',
    answer:
      'QBC (Quick Build Con) is a Gujarat-focused property platform that connects buyers, tenants and owners directly. Listings are verified, and owners can save on traditional brokerage by dealing transparently through QBC.',
  },
  {
    id: 2,
    category: 'general',
    question: 'Which cities does QBC cover?',
    answer:
      'We actively cover Ahmedabad, Rajkot, Surat, Vadodara, Gandhinagar, Jamnagar and Bhavnagar — with more cities being added regularly.',
  },
  {
    id: 3,
    category: 'listing',
    question: 'How do I list my property on QBC?',
    answer:
      'Click "Post Property Free" and complete the simple wizard with photos, location, price and contact details. Your listing goes live after verification — usually within 24 hours.',
  },
  {
    id: 4,
    category: 'listing',
    question: 'Is there a fee to list properties?',
    answer:
      'Basic listing is completely free. Premium packages (from ₹1,500) add featured placement, professional video shoots, reels and social promotion for faster leads.',
  },
  {
    id: 5,
    category: 'listing',
    question: 'How much brokerage can I save by listing on QBC?',
    answer:
      'Traditional brokers typically charge around 1–2% of the deal value. On a ₹50 lakh property, listing and closing through QBC can save ₹75,000 or more compared to paying full brokerage.',
  },
  {
    id: 6,
    category: 'listing',
    question: 'Are all properties on QBC verified?',
    answer:
      'Yes. Our team reviews documents and listing details before publishing. Look for the green Verified badge on premium and verified listings.',
  },
  {
    id: 7,
    category: 'buying',
    question: 'How do I schedule a site visit?',
    answer:
      'Open any property, click "Book Visit", choose your preferred date and time. Our team confirms within 2 hours and coordinates with the owner or builder.',
  },
  {
    id: 8,
    category: 'buying',
    question: 'Can I filter properties by BHK, budget and locality?',
    answer:
      'Yes. Use filters on the properties page for intent (buy/rent/commercial), city, area, BHK, budget range, furnishing and more.',
  },
  {
    id: 9,
    category: 'buying',
    question: 'Does QBC help with home loans or documentation?',
    answer:
      'Our advisors can guide you on RERA compliance, stamp duty, registration steps and connecting with partner banks. Contact us for personalised support.',
  },
  {
    id: 10,
    category: 'premium',
    question: 'What is included in QBC Premium packages?',
    answer:
      'Premium includes verified badge, featured homepage placement, professional photography and video, Instagram/YouTube promotion, lead management and dedicated support.',
  },
  {
    id: 11,
    category: 'premium',
    question: 'How do I book a free property valuation?',
    answer:
      'Use the brokerage savings calculator on our homepage or contact page and click "Book Free Valuation". Our team will call you to discuss your property and marketing options.',
  },
  {
    id: 12,
    category: 'premium',
    question: 'Can builders promote new launches on QBC?',
    answer:
      'Yes. Builders can list projects, run premium campaigns and reach buyers across Gujarat through QBC app, website and social channels. Visit QBC Premium for package details.',
  },
]

/** Short list for homepage */
export const homeFaqs: FAQ[] = mockFaqs.slice(0, 5)
